// extracted by mini-css-extract-plugin
export default {"bold":"inventoryInternal_bold__FduNW","span":"inventoryInternal_span__1vcsk"};